import { render, staticRenderFns } from "./ItemStatusUpdate.vue?vue&type=template&id=29dc8d2b&scoped=true"
import script from "./ItemStatusUpdate.vue?vue&type=script&lang=js"
export * from "./ItemStatusUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc8d2b",
  null
  
)

export default component.exports